import { createClient } from '@/shared/api/client'
import { buildUrl } from '@/shared/utils/urls'
import { TargetSystem } from '@/shared/constants'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export async function removeUploadedFile(id: string) {
  await client.sendDelete(`uploads/${id}`)
}
